import { createFileRoute } from "@tanstack/react-router";
import { SolucionesPanel, type SolucionTab } from "@/components/soluciones-panel";

const TABS: SolucionTab[] = [
  { label: "Mine Pass", to: "/soluciones/acreditacion-contratistas/mine-pass" },
  { label: "Examine", to: "/soluciones/acreditacion-contratistas/examine" },
];

export const Route = createFileRoute("/soluciones/acreditacion-contratistas")({
  head: () => ({
    meta: [
      { title: "Acreditación Contratistas | Mine Class" },
      {
        name: "description",
        content:
          "Acreditación digital para contratistas mineros: Mine Pass, VigIA y Examine centralizan documentos, validaciones y exámenes preocupacionales.",
      },
    ],
    links: [{ rel: "canonical", href: "/soluciones/acreditacion-contratistas" }],
  }),
  component: Layout,
});

function Layout() {
  return (
    <SolucionesPanel
      title="Acreditación Contratistas"
      intro="Digitaliza y acelera el proceso de acreditación minera: documentación, validación con IA y exámenes preocupacionales en un solo ecosistema."
      tabs={TABS}
    />
  );
}
